export default "__VITE_ASSET__CEaJUp0j__"